/**
 * Formats a currency according to the user's locale
 * @param {string} currency The ISO currency code
 * @param {number} value The amount to format
 * @returns {string} The formatted price with currency code
 */
 export const formatPrice = (currency, value) => {
  const formattedValue = Intl.NumberFormat("en-US", {
    currency,
    minimumFractionDigits: 2,
    // style: "currency",
  }).format(value);

  return `${formattedValue} ${currency}`;
}

/**
 * Gets the currency symbol and whether it's positioned at the end
 * @param {string} currency The ISO currency code
 * @param {string} [locale] The locale (optional, defaults to undefined)
 * @returns {Object} The currency symbol and position information
 */
export const getCurrencySymbol = (currency, locale = undefined) => {
  if (!currency) {
    return;
  }

  const formatter = Intl.NumberFormat(locale, {
    currency,
    style: "currency",
  });
  const parts = formatter.formatToParts(100);
  const { value: symbol } = parts.find((part) => part.type === "currency");
  const formatted = formatter.format(100);
  const symbolAtEnd = formatted.endsWith(symbol);
  return { symbol, symbolAtEnd };
}

// Example usage:
// const price = formatPrice("SGD", 1000);
// console.log(price); 
// Outputs: $1,000.00 SGD

// const currencyInfo = getCurrencySymbol("SGD");
// console.log(currencyInfo); 
// Outputs: { symbol: '$', symbolAtEnd: false }